/* eslint-disable jsx-a11y/interactive-supports-focus */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { CSSTransition } from 'react-transition-group';
import { selectFieldOutputAccountsType } from 'mt-react-common/modules/authUserOutputCash/combines/authUserOutputCashFrom/selectors';
import {
  setFieldAccountNumber,
  setFieldOutputAccountsType,
  setFieldBankKey,
  setFieldMemoTag,
  setCommission
} from 'mt-react-common/modules/authUserOutputCash/combines/authUserOutputCashFrom/actions';
import {
  clearErrorByField,
  hasFieldError
} from 'mt-react-common/common/reducers/_formErrors/reducer';
import { connect } from 'react-redux';
import UserOutputCashAccountForm from '../UserOutputCashAccountForm';

// eslint-disable-next-line react/prefer-stateless-function
class UserOutputCashAccountsNavigateItem extends Component {
  constructor(props) {
    super(props);
    this.state = {
      inputId: `formOutputCashAccountType-${this.props.item.id}`
    };
  }

  componentDidMount() {
    // Показываем форму номера счета после монтирования, нужен для того
    //  чтобы отрабатывал show при изменении history браузером
    if (this.props.item.id === this.props.fieldOutputAccountsType.value) {
      // eslint-disable-next-line no-undef
      $(`#formOutputCashAccount${this.props.item.id}`).collapse('show');
    }
  }

  render() {
    return (
      <React.Fragment>
        <div className="radio abc-radio abc-radio-primary">
          <div>
            <input
              type="radio"
              id={this.state.inputId}
              onClick={() => {
                if (this.props.hasFieldError('payout_accounts_type')) {
                  this.props.clearErrorByField('payout_accounts_type');
                  this.props.clearErrorByField('account_number');
                }
                this.props.setFieldOutputAccountsType(
                  this.props.item.id.toString()
                );
                this.props.setFieldAccountNumber(
                  this.props.item.meAccountNumber
                );
                this.props.setFieldBankKey(this.props.item.bankKey);
                this.props.setFieldMemoTag(this.props.item.memoTag);
                this.props.setCommission(
                  this.props.item.totalCommission,
                  this.props.item.fixedCharge
                );
              }}
              checked={
                this.props.item.id.toString() ===
                this.props.fieldOutputAccountsType.value
              }
            />
            <label htmlFor={this.state.inputId}>
              <strong>{this.props.item.title}</strong>{' '}
              {this.props.item.minSumDesc} {this.props.item.commissionDesc}{' '}
              {this.props.item.periodDesc}
            </label>
          </div>
        </div>
        <CSSTransition
          in={
            this.props.item.id.toString() ===
            this.props.fieldOutputAccountsType.value
          }
          classNames=""
          timeout={300}
          unmountOnExit
          onEnter={() => {
            // eslint-disable-next-line no-undef
            $(`#formOutputCashAccount${this.props.item.id}`).collapse('show');
          }}
          onExiting={() => {
            // eslint-disable-next-line no-undef
            $(`#formOutputCashAccount${this.props.item.id}`).collapse('hide');
          }}
        >
          <div
            key={`formOutputCashAccount${this.props.item.id}`}
            id={`formOutputCashAccount${this.props.item.id}`}
            className="collapse"
          >
            <UserOutputCashAccountForm
              reducerNameOutputCashFrom={this.props.reducerNameOutputCashFrom}
              reducerNameOutputCashAccounts={
                this.props.reducerNameOutputCashAccounts
              }
              outputAccountsItem={this.props.item}
            />
            {this.props.item.publicDesc ? (
              <div
                className="col-sm-24 col-xs-24"
                style={{ paddingBottom: '20px' }}
              >
                <div className="alert alert-warning m-b-0">
                  {this.props.item.publicDesc}
                </div>
              </div>
            ) : null}
          </div>
        </CSSTransition>
      </React.Fragment>
    );
  }
}

UserOutputCashAccountsNavigateItem.propTypes = {
  reducerNameOutputCashFrom: PropTypes.string.isRequired,
  reducerNameOutputCashAccounts: PropTypes.string.isRequired,
  item: PropTypes.shape({
    id: PropTypes.number.isRequired,
    title: PropTypes.string.isRequired,
    slug: PropTypes.string.isRequired,
    rate: PropTypes.shape({}).isRequired,
    minSumDesc: PropTypes.string.isRequired,
    commissionDesc: PropTypes.string.isRequired,
    periodDesc: PropTypes.string.isRequired,
    totalCommission: PropTypes.string.isRequired,
    fixedCharge: PropTypes.number.isRequired,
    meAccountNumber: PropTypes.string,
    bankKey: PropTypes.string,
    memoTag: PropTypes.string,
    publicDesc: PropTypes.string
  }).isRequired,
  fieldOutputAccountsType: PropTypes.shape({
    value: PropTypes.string
  }).isRequired,

  hasFieldError: PropTypes.func.isRequired,
  clearErrorByField: PropTypes.func.isRequired,

  setFieldOutputAccountsType: PropTypes.func.isRequired,
  setFieldAccountNumber: PropTypes.func.isRequired,
  setFieldBankKey: PropTypes.func.isRequired,
  setFieldMemoTag: PropTypes.func.isRequired,
  setCommission: PropTypes.func.isRequired
};

const mapStateToProps = (state, props) => ({
  fieldOutputAccountsType: selectFieldOutputAccountsType(
    state,
    props.reducerNameOutputCashFrom
  ),
  hasFieldError: fieldName =>
    hasFieldError(state, props.reducerNameOutputCashFrom, fieldName)
});

const mapDispatchToProps = (dispatch, props) => ({
  clearErrorByField: value =>
    dispatch(clearErrorByField(props.reducerNameOutputCashFrom, value)),
  setFieldOutputAccountsType: value =>
    dispatch(
      setFieldOutputAccountsType(props.reducerNameOutputCashFrom, value)
    ),
  setFieldAccountNumber: value =>
    dispatch(setFieldAccountNumber(props.reducerNameOutputCashFrom, value)),
  setFieldBankKey: value =>
    dispatch(setFieldBankKey(props.reducerNameOutputCashFrom, value)),
  setFieldMemoTag: value =>
    dispatch(setFieldMemoTag(props.reducerNameOutputCashFrom, value)),
  setCommission: (commissionValue, fixedChargeValue) =>
    dispatch(
      setCommission(props.reducerNameOutputCashFrom, {
        totalCommission: commissionValue,
        fixedCharge: fixedChargeValue
      })
    )
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(UserOutputCashAccountsNavigateItem);



// WEBPACK FOOTER //
// ./src/components/UserOutputCash/UserOutputCashForm/UserOutputCashAccountsNavigate/UserOutputCashAccountsNavigateItem.js